export const calcularCubAjustado = (
  cubBase: number,
  ajusteAcabamento: number,
  depreciacao: number
): number => {
  return (cubBase * ajusteAcabamento) * (1 - depreciacao);
};

export const calcularValorFinal = (cubAjustado: number, areaConstruida: number): number => {
  return cubAjustado * areaConstruida;
};

export const formatarMoeda = (valor: number): string => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(valor);
};
